module.exports = __webpack_public_path__ + "static/homepage-f3bb2218be5701003822b3bfcf6c49d9.jpg";